{
  "$schema": "https://json-schema.org/draft/2020-12/schema",
  "title": "Article",
  "type": "object",
  "additionalProperties": false,
  "required": [
    "heading",
    "introHtml"
  ],
  "properties": {
    "heading": {
      "title": "Heading",
      "type": "string",
      "maxLength": 200
    },
    "subheading": {
      "title": "Subheading",
      "type": "string",
      "maxLength": 200
    },
    "imageMediaId": {
      "title": "Image",
      "type": [
        "string",
        "null"
      ],
      "pattern": "^[0-9a-fA-F-]{36}$",
      "x-ui": "media"
    },
    "introHtml": {
      "title": "Text",
      "type": "string",
      "maxLength": 20000,
      "x-ui": "richtext"
    },
    "quote": {
      "title": "Quote box",
      "type": "string",
      "maxLength": 1500,
      "x-ui": "textarea"
    },
    "bodyHtml": {
      "title": "Text after quote",
      "type": "string",
      "maxLength": 20000,
      "x-ui": "richtext"
    }
  }
}
